import { useEffect, useRef } from "react";

// Phones keep the tab alive in the background, so a job withdrawn meanwhile would otherwise stay on screen.
export const useRefetchOnForeground = (onForeground: () => void): void => {
  const latest = useRef(onForeground);
  latest.current = onForeground;

  useEffect(() => {
    const onVisibilityChange = () => {
      if (document.visibilityState === "visible") latest.current();
    };
    document.addEventListener("visibilitychange", onVisibilityChange);
    return () => document.removeEventListener("visibilitychange", onVisibilityChange);
  }, []);
};
